import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts, Spacing } from "@snapchat/snap-design-system";

export const spacingTop = css`
    margin-top: ${Spacing.LG}px;
`;

export const WelcomeTitle = styled.h1`
    ${Fonts.Heading.H400};
    margin-bottom: ${Spacing["1XS"]}px;
`;

export const WelcomeParagraph = styled.p`
    ${Fonts.Paragraph.P200}
    margin-bottom: 0;
    color: ${Colors.Gray.V300};
`;

export const WelcomeNote = styled.p`
    max-width: 75%;
    margin-top: ${Spacing.LG}px;
    font-style: italic;
    ${Fonts.Paragraph.P300}
`;
